import { render, staticRenderFns } from "./BsDistToRegCenForm.vue?vue&type=template&id=f21dd040&scoped=true&"
import script from "./BsDistToRegCenForm.vue?vue&type=script&lang=js&"
export * from "./BsDistToRegCenForm.vue?vue&type=script&lang=js&"
import style0 from "./BsDistToRegCenForm.vue?vue&type=style&index=0&id=f21dd040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dd040",
  null
  
)

export default component.exports